import { useRecoilState } from 'recoil'
import { userProfileAtom } from '../../store/userProfile'
import { Avatar, Space } from 'antd'
import { UserOutlined } from '@ant-design/icons'

const HeaderPointCharge = () => {
  const [userProfile] = useRecoilState(userProfileAtom)
  return (
    <div className='text-[#00D4FF] p-5 flex justify-end'>
      {userProfile?.availablePoint >= 0 && (
        <div className='flex items-center mr-5'>
          <img
            src='/logo.png'
            alt='NotBotti'
            className='w-8 mr-2 font-semibold'
          />
          {userProfile.availablePoint}pt
        </div>
      )}
      <Space>
        {userProfile?.avatar ? (
          <Avatar src={userProfile.avatar} />
        ) : (
          <Avatar icon={<UserOutlined />} />
        )}
        {userProfile?.username}
      </Space>
    </div>
  )
}

export default HeaderPointCharge
